import axios from 'axios';
import get from 'lodash/get';

export const ISSUE_DISPUTE_LOADING = 'ISSUE_DISPUTE_LOADING';
export const ISSUE_DISPUTE_READY = 'ISSUE_DISPUTE_READY';
export const ISSUE_DISPUTE_UNAUTHORIZED = 'ISSUE_DISPUTE_UNAUTHORIZED';
export const ISSUE_DISPUTE_SUBMITTING = 'ISSUE_DISPUTE_SUBMITTING';
export const ISSUE_DISPUTE_CREATED = 'ISSUE_DISPUTE_CREATED';
export const ISSUE_DISPUTE_ERROR = 'ISSUE_DISPUTE_ERROR';

export function createOrUpdateIssueDispute(issueId, issueSecret, reason) {
  return dispatch => {
    dispatch({ type: ISSUE_DISPUTE_SUBMITTING });

    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/issues/${issueId}/respond/${issueSecret}/dispute`,
        {
          issueId,
          issueSecret,
          reason
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
      .then(response => {
        dispatch({
          type: ISSUE_DISPUTE_CREATED,
          payload: response.data.data
        });
      })
      .catch(error => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { _error: 'Network Error' };
        }

        dispatch({
          type: ISSUE_DISPUTE_ERROR,
          payload: response
        });
      });
  };
}

export function authorizeIssueDispute(issueId, issueSecret) {
  return dispatch => {
    dispatch({ type: ISSUE_DISPUTE_LOADING });

    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/issues/${issueId}/respond/${issueSecret}/dispute`,
        null,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
      .then(response => {
        dispatch({
          type: ISSUE_DISPUTE_READY,
          payload: response.data.data
        });
      })
      .catch(error => {
        if (process.env.NODE_ENV !== 'production') {
          console.log('catch', error);
        }

        let response = get(error, 'response.data');
        if (!response) {
          response = { _error: 'Network Error' };
        }

        dispatch({
          type: ISSUE_DISPUTE_UNAUTHORIZED,
          payload: response
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/issueDisputeActions.js